import React from "react"
import { HeartIcon } from "@heroicons/react/24/outline"
import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid"
import { twMerge } from "tailwind-merge"
import useT from "../hooks/useT"
import useClientAuth from "../hooks/useClientAuth"
import { useFavorite } from "../store/account"
import { requestSignIn } from "../utils/signIn"

/**
 * Heart that adds a product to the account's Favorites (/library/favorites)
 * or takes it off; a guest is sent to sign in and brought back to the product.
 * A favorite's heart is filled with the primary colour; fillOnHover fills the
 * empty heart (in the button's own colour) while it is hovered.
 */
export default function FavoriteButton({ product, className = "", iconClassName = "w-5 h-5", fillOnHover = false }) {
  const t = useT()
  const { auth } = useClientAuth()
  const { isFavorite, toggle } = useFavorite(product)
  const label = isFavorite ? t`Added to favorites` : t`Add to favorites`

  const onClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (!auth) return requestSignIn()
    toggle()
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      aria-pressed={isFavorite}
      title={label}
      data-testid="card-favorite"
      className={twMerge("group/fav inline-flex shrink-0 items-center justify-center", isFavorite ? "text-primary" : "text-text_secondary hover:text-primary", className)}
    >
      {isFavorite ? (
        <HeartSolid className={twMerge(iconClassName, "text-primary")} />
      ) : fillOnHover ? (
        <>
          <HeartIcon className={twMerge(iconClassName, "group-hover/fav:hidden")} />
          <HeartSolid className={twMerge(iconClassName, "hidden group-hover/fav:block")} />
        </>
      ) : (
        <HeartIcon className={iconClassName} />
      )}
    </button>
  )
}
